/** @type {import('@vue/compat').ComponentOptions} */
export default {
  data: {
    data: [],
    step: 0,
    currentVerifyData: {},
    status: 0,
    opinion: '',
    locked: false,
    protocol: false,
    formData: {
      index: 0,
      type: '',
      title: '',
      company: '',
      credit_code: '',
      business_license: '',
      business_auth: '',
      official_site: '',
      supplement: '',
      operator: '',
      email: '',
      telephone: '',
      id_card: '',
      idcard_hand: '',
      idcard_front: '',
      idcard_verso: '',
    },
  },
  mounted() {
    this.getUserVerifyInfo();
  },
  computed: {
    unsatisfiedCount() {
      const countByType = {};
      this.data.forEach((item) => {
        const unsatisfied = item.conditions.filter((condition) => !condition.allow).length;
        if (!countByType[item.type]) {
          countByType[item.type] = unsatisfied;
        } else {
          countByType[item.type] += unsatisfied;
        }
      });
      return countByType;
    },
  },
  methods: {
    getVerifyInfo() {
      this.$http.post(`${qk_rest_url}getVerifyInfo`).then((res) => {
        this.data = res.data;
        this.data.forEach((item) => {
          item.conditions.sort((a, b) => (a.allow === b.allow ? 0 : a.allow ? -1 : 1));
        });
        this.formData.index = this.data.findIndex((item) => item.type === this.formData.type);
        this.$nextTick(() => {
          this.currentVerifyData = this.data[this.formData.index];
        });
      }).catch((err) => {
        qkShowApiError(err, '加载认证信息失败');
      });
    },
    getUserVerifyInfo() {
      this.$http.post(`${qk_rest_url}getUserVerifyInfo`).then((res) => {
        const data = res.data;
        this.step = data.step;
        this.status = data.status;
        this.opinion = data.opinion;
        this.formData = { ...this.formData, ...data.data };
        this.formData.type = data.type;
        this.formData.title = data.title;
        this.getVerifyInfo();
      }).catch((err) => {
        qkShowApiError(err, '加载认证信息失败');
      });
    },
    onNext(val, index) {
      this.currentVerifyData = val;
      this.step = 2;
      this.formData.type = val.type;
      this.formData.index = index;
    },
    onPrev() {
      this.step -= this.step === 4 ? 2 : 1;
      this.status = 0;
    },
    pay(data, index) {
      if (!qktoken) return this.$createModal('login');
      qkpay({
        title: this.data[index].name,
        order_price: data.value,
        order_type: 'verify',
        order_key: index,
        order_value: this.data[index].type,
        type: data.key,
        tag: '认证付费',
      }, data.key);
    },
    handleUpload(event, type) {
      if (this.locked) return;
      this.locked = true;

      const file = event.target.files[0];
      this.formData[type] = URL.createObjectURL(file);
      const formData = new FormData();
      formData.append('file', file, file.name);
      formData.append('post_id', 1);
      formData.append('type', 'verify');

      this.$http.post(`${qk_rest_url}fileUpload`, formData).then((res) => {
        this.locked = false;
        this.formData[type] = res.data.url;
      }).catch((err) => {
        this.formData[type] = '';
        const msg = qkGetApiError(err, '上传失败') || '上传失败，请重新上传';
        this.$message({ message: msg, type: 'warning' });
        this.locked = false;
      });

      this.$refs.uploadInput.value = null;
    },
    submitVerify() {
      if (this.locked) return;
      this.locked = true;
      this.$http.post(`${qk_rest_url}submitVerify`, this.formData).then(() => {
        this.step = 3;
        this.$message({ message: '申请已提交，等待认证审核', type: 'success' });
        this.locked = false;
      }).catch((err) => {
        this.locked = false;
        this.$message({ message: qkGetApiError(err, '操作失败'), type: 'error' });
      });
    },
  },
};
